import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Toolbar } from 'framework-ui-components';
import { withRouter } from 'react-router-dom';
import LoadingPanel from '../LoadingPanel';

class PageWrapper extends Component {
    handlePageBack = () => {
      const { onPageBack, history } = this.props;
      if (onPageBack) {
        onPageBack();
      } else {
        history.goBack();
      }
    }

    render() {
      const {
        children,
        helmetTitle,
        isLoadingPage,
        pageActions,
        pageBack,
        pageButtons,
        pageTitle,
        className
      } = this.props;

      return (
        <div className="page__wrapper__container">
          {helmetTitle && <Helmet title={helmetTitle} /> }
          <LoadingPanel isLoading={isLoadingPage || false}>
            <div className="page__wrapper">
              <div className="toolbar__container">
                <Toolbar
                  back={pageBack}
                  onBack={this.handlePageBack}
                  title={pageTitle}
                  actions={pageActions}
                  buttons={pageButtons}
                />
              </div>
              <div className={"page__container" + (className!=null ? (" "+className): "")}>
                {children}
              </div>
            </div>
          </LoadingPanel>
        </div>
      );
    }
}

PageWrapper.defaultProps = {
  children: null,
  helmetTitle: null,
  isLoadingPage: false,
  onPageBack: null,
  pageActions: null,
  pageBack: false,
  pageButtons: null,
};

PageWrapper.propTypes = {
  children: PropTypes.element,
  helmetTitle: PropTypes.string,
  isLoadingPage: PropTypes.bool,
  onPageBack: PropTypes.func,
  pageActions: PropTypes.element,
  pageBack: PropTypes.bool,
  pageButtons: PropTypes.element,
  pageTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(PageWrapper);
